// Memorial entry for Ohad Yahalomi
import ohadYahalomiPortrait from '../../../images/ohad-yahalomi.jpg';

export const ohadYahalomiMemorial = {
  id: 34,
  name: 'Ohad Yahalomi',
  images: {
    portrait: ohadYahalomiPortrait
  },
  info: `
"The last image his children have of their father is him lying on the floor, wounded and bleeding, after he left the safe room to protect them."

# Ohad Yahalomi

![Ohad Yahalomi](${ohadYahalomiPortrait})
*Ohad Yahalomi, 49, ranger, commando, father - a man of the desert*

## A Life in Nature

Ohad Yahalomi was a man of the desert. For 19 years, he worked for the Israel Nature and Parks Authority - leading hikes, supervising the Judean Desert, directing the "green patrol." He knew every trail in the Negev. In 2018, he co-authored "Scorpions of Israel Field Guide."

He also served in reserve duty for the elite Maglan commando unit. About 13 years before his death, he settled in Kibbutz Nir Oz with his wife Batsheva and children Eitan, Yael, and Liel.

## October 7, 2023

At 6:30 a.m., the family awoke to gunshots. Their safe room door handle was broken. Drawing on his commando training, Ohad sat outside the door with only a handgun.

After two hours, terrorists broke in. Ohad engaged them. He was shot in the leg before being overwhelmed.

The terrorists put Batsheva and the children on mopeds toward Gaza. The last image his children have: Ohad lying wounded and bleeding on the floor. He told them he loved them.

Near the border, IDF tanks appeared. The moped crashed. Batsheva escaped with Yael and Liel into the fields. But 12-year-old Eitan was taken to Gaza.

## Father and Son

Eitan spent 52 days in solitary, told "Israel didn't exist." He was released November 27, 2023.

Ohad died January 19, 2024 - 104 days in captivity.

His body returned February 26, 2025. At the funeral, his mother cried: "They took my diamond."

Batsheva: "Sixteen years of joy and light, and the light has now gone out."

*A man who loved both people and the land. May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/ohad-yahalomi-49-park-ranger-who-knew-every-trail/)
`
};
